import React from 'react';
import './Navbar.css';

function Navbar() {
  const marketingUrl = process.env.REACT_APP_MARKETING_URL || 'https://forge-io.com';

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <a href={marketingUrl} className="navbar-brand">
          <img src="/images/logo.png" alt="Forge Logo" className="navbar-logo" />
          <h1>Forge</h1>
        </a>

        <div className="navbar-nav">
          <a href={`${marketingUrl}/services`} className="nav-link">Services</a>
          <a href={`${marketingUrl}/contact`} className="nav-link">Contact</a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
